export const WEB_APP_URL = import.meta.env.VITE_WEB_APP_URL;
export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const DATE_FORMAT_HINT = 'MM/DD/YYYY';
